import React from 'react';

import * as Styled from './calendar-color-bar.style';

export type CalendarColorBarProps = {
  color: string;
};

export const CalendarColorBar: React.FC<CalendarColorBarProps> = ({
  color,
}) => <Styled.Bar $color={color} />;
